import { useMarkNotificationRead } from "@/http/api-hooks";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

export function NotificationOpen() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { trigger: markRead } = useMarkNotificationRead();

  useEffect(() => {
    const to = searchParams.get("to") ?? "/";
    if (id) {
      markRead(parseInt(id, 10)).finally(() => navigate(to));
    } else {
      navigate(to);
    }
  }, []);

  return null;
}
